export default __webpack_public_path__ + "static/media/photos.ad5154f0.jpg";